import { getFinancialSidebarTarget, getInventorySidebarTarget, } from './permissions';
import { buildPatientLogTourSteps } from './patientLogTour';
var reservationSteps = function (t) { return [
    {
        element: '[data-onboarding="sidebar-reservation-packages"]',
        popover: {
            title: t('reservation.steps.sidebar.title'),
            description: t('reservation.steps.sidebar.description'),
        },
    },
    {
        element: '[data-onboarding="page-add-button"]',
        popover: {
            title: t('reservation.steps.add.title'),
            description: t('reservation.steps.add.description'),
        },
    },
    {
        element: '[data-onboarding="page-list"]',
        popover: {
            title: t('reservation.steps.list.title'),
            description: t('reservation.steps.list.description'),
        },
    },
]; };
var packageSteps = function (t) { return [
    {
        element: '[data-onboarding="sidebar-other"]',
        popover: {
            title: t('package.steps.otherMenu.title'),
            description: t('package.steps.otherMenu.description'),
        },
    },
    {
        element: '[data-onboarding="sidebar-packages"]',
        popover: {
            title: t('package.steps.sidebar.title'),
            description: t('package.steps.sidebar.description'),
        },
    },
    {
        element: '[data-onboarding="page-add-button"]',
        popover: {
            title: t('package.steps.add.title'),
            description: t('package.steps.add.description'),
        },
    },
    {
        element: '[data-onboarding="page-list"]',
        popover: {
            title: t('package.steps.list.title'),
            description: t('package.steps.list.description'),
        },
    },
]; };
var patientHistorySteps = function (t) { return [
    {
        element: '[data-onboarding="sidebar-patients"]',
        popover: {
            title: t('patientHistory.steps.sidebar.title'),
            description: t('patientHistory.steps.sidebar.description'),
        },
    },
    {
        element: '[data-onboarding="patient-search"]',
        popover: {
            title: t('patientHistory.steps.search.title'),
            description: t('patientHistory.steps.search.description'),
        },
    },
    {
        element: '[data-onboarding="page-list"]',
        popover: {
            title: t('patientHistory.steps.list.title'),
            description: t('patientHistory.steps.list.description'),
        },
    },
    {
        popover: {
            title: t('patientHistory.steps.openPatient.title'),
            description: t('patientHistory.steps.openPatient.description'),
        },
    },
]; };
var activatePatientAppointmentsTab = function (element) {
    var _a, _b;
    var tabNode = (_a = element === null || element === void 0 ? void 0 : element.closest('.ant-tabs-tab')) !== null && _a !== void 0 ? _a : (_b = document
        .querySelector('[data-onboarding="patient-appointments-tab"]')) === null || _b === void 0 ? void 0 : _b.closest('.ant-tabs-tab');
    tabNode === null || tabNode === void 0 ? void 0 : tabNode.click();
};
var patientProfileSteps = function (t) { return [
    {
        element: '[data-onboarding="patient-personal-info"]',
        popover: {
            title: t('patientProfile.steps.personalInfo.title'),
            description: t('patientProfile.steps.personalInfo.description'),
        },
    },
    {
        element: '[data-onboarding="patient-tabs"]',
        popover: {
            title: t('patientProfile.steps.tabs.title'),
            description: t('patientProfile.steps.tabs.description'),
        },
    },
    {
        element: '[data-onboarding="patient-appointments-tab"]',
        onHighlightStarted: activatePatientAppointmentsTab,
        popover: {
            title: t('patientProfile.steps.appointmentsTab.title'),
            description: t('patientProfile.steps.appointmentsTab.description'),
        },
    },
    {
        element: '[data-onboarding="patient-appointments-list"]',
        waitForElement: 400,
        popover: {
            title: t('patientProfile.steps.appointmentsList.title'),
            description: t('patientProfile.steps.appointmentsList.description'),
        },
    },
    {
        element: '[data-onboarding="patient-actions"]',
        popover: {
            title: t('patientProfile.steps.actions.title'),
            description: t('patientProfile.steps.actions.description'),
        },
    },
]; };
var patientLogSteps = function (t) { return buildPatientLogTourSteps(t); };
var appointmentSteps = function (t) { return [
    {
        element: '[data-onboarding="sidebar-appointments"]',
        popover: {
            title: t('appointment.steps.sidebar.title'),
            description: t('appointment.steps.sidebar.description'),
        },
    },
    {
        element: '[data-onboarding="page-search"]',
        popover: {
            title: t('appointment.steps.search.title'),
            description: t('appointment.steps.search.description'),
        },
    },
    {
        element: '[data-onboarding="page-list"]',
        popover: {
            title: t('appointment.steps.list.title'),
            description: t('appointment.steps.list.description'),
        },
    },
    {
        popover: {
            title: t('appointment.steps.create.title'),
            description: t('appointment.steps.create.description'),
        },
    },
]; };
var inventorySteps = function (t) { return [
    {
        element: '[data-onboarding="sidebar-inventory"]',
        popover: {
            title: t('inventory.steps.menu.title'),
            description: t('inventory.steps.menu.description'),
        },
    },
    {
        element: getInventorySidebarTarget(),
        popover: {
            title: t('inventory.steps.section.title'),
            description: t('inventory.steps.section.description'),
        },
    },
    {
        element: '[data-onboarding="page-add-button"]',
        popover: {
            title: t('inventory.steps.add.title'),
            description: t('inventory.steps.add.description'),
        },
    },
    {
        element: '[data-onboarding="page-list"]',
        popover: {
            title: t('inventory.steps.list.title'),
            description: t('inventory.steps.list.description'),
        },
    },
]; };
var financialSteps = function (t) { return [
    {
        element: '[data-onboarding="sidebar-accounting"]',
        popover: {
            title: t('financial.steps.menu.title'),
            description: t('financial.steps.menu.description'),
        },
    },
    {
        element: getFinancialSidebarTarget(),
        popover: {
            title: t('financial.steps.section.title'),
            description: t('financial.steps.section.description'),
        },
    },
    {
        element: '[data-onboarding="page-add-button"]',
        popover: {
            title: t('financial.steps.add.title'),
            description: t('financial.steps.add.description'),
        },
    },
    {
        element: '[data-onboarding="page-list"]',
        popover: {
            title: t('financial.steps.list.title'),
            description: t('financial.steps.list.description'),
        },
    },
]; };
var TOUR_STEP_BUILDERS = {
    reservation: reservationSteps,
    package: packageSteps,
    patientHistory: patientHistorySteps,
    patientProfile: patientProfileSteps,
    appointment: appointmentSteps,
    patientLog: patientLogSteps,
    inventory: inventorySteps,
    financial: financialSteps,
};
export var buildTourSteps = function (tourId, t) {
    return TOUR_STEP_BUILDERS[tourId](t);
};
export var getTourTitleKey = function (tourId) {
    return "".concat(tourId, ".title");
};
export var getTourDescriptionKey = function (tourId) {
    return "".concat(tourId, ".description");
};
